import React from 'react';
import { Col, Card, Button } from 'react-bootstrap';
import CsLineIcons from 'cs-line-icons/CsLineIcons';

const DashboardCard = ({ img = '', title = '', subTitle = '', description = '', url = '', btnTitle = '' }) => {
  return (
    <Col sm="12" md="3" lg="3" xxl="3" className="w-24">
      <Card className="h-100-card hover-img-scale-up mx-auto mb-3  border-blue" style={{ minHeight: '300px', maxWidth: '490px', backgroundColor: '#f1f1f1' }}>
        <Card.Body className="d-flex flex-column justify-content-between align-items-start   bg-white card-img-overlay">
          <div className="min-h-160">
            <div className="cta-3">{title}</div>
            <div className="mb-3 cta-3 text-primary">{subTitle}</div>
            <div className="text-alternate mb-4">{description}</div>
          </div>
          <img src={img} className="w-50  h-80 scale object-fit-contain" alt="card image" />
          <Button
            className="btn-icon w-auto btn-primary btn-icon  text-primary p-0 mt-2 text-left border-0 bg-white btn-icon-start ms-0 ms-sm-1"
            onClick={(e) => {
              e.preventDefault();
              window.open(url);
            }}
          >
            <CsLineIcons icon="play_c" />
            <span className="ps-2">{btnTitle}</span>
          </Button>
        </Card.Body>
      </Card>
    </Col>
  );
};
export default DashboardCard;
